import { Flex, styled } from '@shared/components';
import type { PropsWithChildren } from '@shared/utils';

export type RichTextEditorControlGroupProps = PropsWithChildren;

const RichTextEditorControlGroupWrapper = styled(Flex)(({ theme }) => ({
  '& [data-rich-text-editor-control]': {
    borderRadius: theme.shape.rounded(0),
    backgroundColor: theme.palette.background.paper,
    '&:not(:last-of-type)': {
      borderInlineEndWidth: 0,
    },
    '&:last-of-type': {
      borderTopRightRadius: theme.shape.rounded(1),
      borderBottomRightRadius: theme.shape.rounded(1),
    },
    '&:first-of-type': {
      borderTopLeftRadius: theme.shape.rounded(1),
      borderBottomLeftRadius: theme.shape.rounded(1),
    },
  },
}));

export default function RichTextEditorControlGroup(
  props: Readonly<RichTextEditorControlGroupProps>,
) {
  const { children } = props;
  return (
    <RichTextEditorControlGroupWrapper role='toolbar'>{children}</RichTextEditorControlGroupWrapper>
  );
}
